import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.css";
import { paths } from "@/routes/paths";
import { isInLocalKonnectApp, openScreen } from "@/utils/responsive";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    if (isInLocalKonnectApp) {
      openScreen("HomeBottomTabsScreen");
    } else {
      navigate(paths.sports.home);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-icon">🔍</div>
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="not-found-actions">
          <button
            onClick={handleGoHome}
            className="not-found-button primary-button"
          >
            Go to Home
          </button>
          <button
            onClick={handleGoBack}
            className="not-found-button secondary-button"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
